import { LAG_GS } from 'AppConfig/Config';
import { useSelector } from 'react-redux';
import { userContainsRole } from 'Redux/Query';

export const RatingCode = ({ value, record }) => {
  const checkUserRole = useSelector(userContainsRole);

  return checkUserRole([ LAG_GS ]) || record.lagRatingResponseDate ? value : ''
}
